import AppContext from "PFApp/app_context";
import { useContext } from "react";

export const usePastDaysLimit = (): number | undefined => {
  const {
    store: {
      currentAccount: { availability }
    }
  } = useContext(AppContext);

  const { past_days_limit: pastDaysLimit } = availability || {};

  return pastDaysLimit;
};
